import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Chromecast from './chromecast';

import { connect } from 'react-redux';
import {connectCast} from './actions/cast';

class Header extends Component{
  constructor(props){
    super(props);
    this.onCastClicklHandler = this.onCastClicklHandler.bind(this);
  }
  onCastClicklHandler(){
      this.props.dispatch(connectCast())
  }
  render(){
    return (
      <AppBar position="static" color="default" className="header">
       <Toolbar>
         <Typography className="title" type="title" color="inherit">
           BGTV - Гледай безплатна телевизия.
         </Typography>
       </Toolbar>
     </AppBar>
    )
  }
}

const mapStateToProps = (state, ownProps)=>{
  return{
     cast:state.cast
  }
}
export default connect(mapStateToProps)(Header);



// WEBPACK FOOTER //
// ./src/header.js